module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0008.jpg?v=71783732";